export default __webpack_public_path__ + "static/media/elegant-white-logo.7c900e9a.svg";